import $ from 'jquery'
import 'slick-carousel'

$(document).ready(function() {
  dhsv_vc_infografic()
})

function wordsAddSpans(parentNode, strongText, regularText) {
  $(parentNode).each(function() {
    let firstWords = $(strongText, this)
      .html()
      .split(' ')
    let secondtWords = $(regularText, this)
      .html()
      .split(' ')
    firstWords = $.grep(firstWords, function(v) {
      if (v.length !== 0 && v.trim()) {
        return v
      }
    })
    secondtWords = $.grep(secondtWords, function(v) {
      if (v.length !== 0 && v.trim()) {
        return v
      }
    })
    $.each(firstWords, function(i, v) {
      firstWords[i] = `<strong>${v}</strong>`
    })
    const allWords = [...firstWords, ...secondtWords]
    $.each(allWords, function(i, v) {
      allWords[i] = `<span class="word word-${i}">${v}</span>`
    })
    $(this).append(allWords.join(' '))
  })
}

function dhsv_vc_infografic() {
  wordsAddSpans('.js-infografic-tab', '.js-tab-bold', '.js-tab-regular')
  $('.infografic__image .st2, .infografic__image .tab').click(function() {
    $(
      '.infografic__middle-wrapper, .infografic__image .st2, ' +
        '.infografic__image .st1, .infografic__image .st6, ' +
        '.infografic__tab-content-mobile, .infografic__image .tab, .numbers'
    ).removeClass('active')
    $('.infografic__initial-wrapper').addClass('inactive')
    const theId = parseInt(
      $(this)
        .attr('id')
        .replace(/[^\d]/g, ''),
      10
    )
    $(this).addClass('active')
    $(`.infografic__middle-wrapper[data-index="${theId}"]`).addClass('active')
    $(`.grafic-number-${theId}`).addClass('active')
    $(`.grafic-dot-${theId}`).addClass('active')
    $(`.infografic__tab-content-${theId}`).addClass('active')
    $('.js-infografic-slider').slick('slickGoTo', theId - 1)
  })

  $('.js-infografic-slider').slick({
    arrows: false,
    dots: true,
    infinite: false,
    variableWidth: true,
  })
}
